export enum CurrencyId {
  EUR = 1,
  RUB = 2,
  USD = 3,
  GBP = 4,
  HUF = 5,
  AMD = 6,
}

export enum CurrencySymbol {
  EUR = "€",
  RUB = "₽",
  USD = "$",
  GBP = "£",
  HUF = "Ft",
  AMD = "֏",
}
